import { render, staticRenderFns } from "./Fpa.vue?vue&type=template&id=20f48fba&scoped=true"
import script from "./Fpa.vue?vue&type=script&lang=js"
export * from "./Fpa.vue?vue&type=script&lang=js"
import style0 from "./Fpa.vue?vue&type=style&index=0&id=20f48fba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f48fba",
  null
  
)

export default component.exports